
import Vue from 'vue'
import EMAIl_ICON from 'common/icon-mail-default.svg'
import WHATSAPP_ICON from 'common/icon-whatsapp.svg'

interface ContactItem {
  link?: string,
  title: string,
  info: string,
  icon: string
}

export default Vue.extend({
  name: 'HeaderContact',

  data(): {
    contactItems: ContactItem[]
  }{
    return {
      contactItems: [{
        title: 'Email',
        info: 'customer-service@custa.com',
        icon: EMAIl_ICON
      },
        {
          title: 'Phone/WA',
          link: 'https://api.whatsapp.com/send?phone=60177112285',
          info: '+60 177112285',
          icon: WHATSAPP_ICON
        }
      ]
    }
  }
})
